import React from "react";
import Slider from "react-slick";
import NewsCard from "./NewsCard";
import { NewsItem } from "../types/types";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

interface NewsSliderProps {
  news: NewsItem[];
}

const NewsSlider: React.FC<NewsSliderProps> = ({ news }) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    adaptiveHeight: true,
  };

  if (!news || news.length === 0) {
    return null;
  }

  return (
    <div className="w-full news-slider-container">
      <style>{`
        .news-slider-container .slick-dots {
          bottom: -30px;
        }
        .news-slider-container .slick-dots li button:before {
          font-size: 10px;
          color: #d4af37; /* mauritania-gold */
        }
        .news-slider-container .slick-dots li.slick-active button:before {
          color: #006b3f; /* mauritania-green */
        }
      `}</style>
      <Slider {...settings}>
        {news.map((item) => (
          <div key={item.id} className="pb-4 pt-2 px-1">
            <NewsCard news={item} imageHeight="h-48" />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default NewsSlider;
